<script setup lang="ts">
import { computed, inject } from 'vue';
import { SHARE_CERT_DOC_CTX } from '../shareCertContext';

const ctx = inject(SHARE_CERT_DOC_CTX)!;
const options = computed(() => ctx.certOptions());
const selected = computed(() => String(ctx.valueOf('cert_no') || ''));

function onChange(e: Event) {
  const el = e.target as HTMLSelectElement | null;
  ctx.selectCertNo(String(el?.value || ''));
}
</script>

<template>
  <select class="sc-cert-select" :value="selected" @change="onChange">
    <option value="">{{ options.length ? 'Select certificate no.' : 'Select holder first' }}</option>
    <option v-for="opt in options" :key="opt.value" :value="opt.value">
      {{ opt.title }}
    </option>
  </select>
</template>

<style scoped>
.sc-cert-select {
  width: 100%;
  border: 1px solid #e4cf90;
  border-radius: 4px;
  padding: 2px 6px;
  background: #fff9e7;
  color: #7a6a3a;
  font: inherit;
  font-style: italic;
}
</style>
